var _path;
import * as React from "react";
function SvgEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.16a3.841 3.841 0 010 7.68 3.841 3.841 0 010-7.68zm-3.84-8.32a3.841 3.841 0 007.68 0 3.841 3.841 0 00-7.68 0zm0 24.32a3.841 3.841 0 007.68 0 3.841 3.841 0 00-7.68 0z"
  })));
}
export default SvgEllipsis;